const deepBlue = {
  100: '#1F61A3'
};

export { deepBlue };
